/* eslint-disable no-param-reassign */
import React from 'react';
import SimpleSingleSelectPage from 'pages/wholeme/molecules/simpleSingleSelectPage/SimpleSingleSelectPage';
import { fieldsFor } from '../../../util/profile_field_data';
import appStrings from '../../../../../common/app_strings';

const { wholeMe: { wholeMeGenderIntake } } = appStrings;

const ProfileIdentityIntakeGenderPage = ({
  paginationMeta,
  nextOnClick,
  prevOnClick,
  wholeMeClient,
  exitIconOnClickOverride,
}) => {
  const dataFetcher = wholeMeClient.fetchGenderState;
  const dataSaver = wholeMeClient.saveGenderState;

  return (
    <SimpleSingleSelectPage
      fields={fieldsFor('identity-gender')}
      paginationMeta={paginationMeta}
      nextOnClick={nextOnClick}
      prevOnClick={prevOnClick}
      title={wholeMeGenderIntake.title}
      subtitle={wholeMeGenderIntake.subtitle}
      backgroundOverlay="/assets/profile/identity/gender-page-background-overlay.svg"
      categoryId="identity"
      questionId="gender"
      dataFetcher={dataFetcher}
      dataSaver={dataSaver}
      allowForDisabledButtonState
      exitIconOnClickOverride={exitIconOnClickOverride}
      skipPersonalization
    />
  );
};

export default ProfileIdentityIntakeGenderPage;
